module.exports = __webpack_public_path__ + "static/media/puzzle.8ff28aa2.svg";